import React, { useState, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import { Box, Container, Typography, Button, Select, MenuItem, Card, Grid, IconButton, Dialog, Tooltip, DialogTitle, DialogContent, DialogActions, Alert, Stack, Fade, Zoom } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import { FaVolumeMute, FaVolumeUp, FaArrowDown, FaCrown } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useUserPermissions } from "../components/useUserPermissions.tsx";
import TokenIcon from '../assets/images/Token.png'; 
import OpeningSound from '../assets/sounds/OpeningSound.MP3';
const getRarityColor = (rarity: string = "common") => {
  const colors: Record<string, string> = {
    common: "linear-gradient(45deg, #666666 30%, #999999 90%)",
    rare: "linear-gradient(45deg, #0088ff 30%, #00c6ff 90%)",
    epic: "linear-gradient(45deg, #aa00ff 30%, #cc66ff 90%)",
    legendary: "linear-gradient(45deg, #ffaa00 30%, #ffcc00 90%)"
  };
  return colors[rarity] || colors.common;
};

export interface Reward {
  id: string;
  name: string;
  rarity: string;
  price: number;
  image: string;
  productType?: { // új mező!
    id: number;
    typeName: string;
  };
}

const easeOut = (t: number) => 1 - Math.pow(1 - t, 3);

const TranslatedItems = styled(Box)<{ offset: number }>(({ offset }) => ({
  display: "flex",
  transition: "none",
  transform: `translateX(-${offset}px)`,
  //maxWidth: "130px",
  willChange: "transform",
}));

const rotate3d = keyframes({
  '0%': { transform: 'rotateY(0deg)' },
  '100%': { transform: 'rotateY(360deg)' }
});

const Transition = React.forwardRef(function Transition(
  props: any,
  ref: React.Ref<unknown>,
) {
  return (
    <Zoom 
      ref={ref} 
      {...props} 
      // Az easing (időzítési függvény) teszi "pattanóssá" a zárást is
      easing={{
        enter: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        exit: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)'
      }}
      timeout={{ enter: 500, exit: 400 }} 
    />
  );
});

// A látható ablak szélessége: 11 elem, azaz 11 * 130 = 1430px.
const containerWidthValue = 1430;
const itemWidthValue = 82;

const StyledCase = styled(Card)(({ theme }) => {
  const isDarkMode = theme.palette.mode === 'dark';
  return {
    // Az általad kért specifikus színvilág
    background: isDarkMode 
      ? 'linear-gradient(45deg, #000000 10%, #5e0b0b 50%, #000000 90%)' 
      : 'linear-gradient(45deg, #25379c 30%, #21cbf3 90%)',
    color: '#ffffff', // Világos módban is legyen fehér a szöveg a kék háttéren
    padding: "20px",
    marginBottom: "20px",
    cursor: "pointer",
    borderRadius: "20px",
    border: `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.3)'}`,
    boxShadow: isDarkMode ? "0 8px 32px rgba(0,0,0,0.8)" : "0 8px 32px rgba(37, 55, 156, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: isDarkMode ? "0 12px 40px rgba(94, 11, 11, 0.4)" : "0 12px 40px rgba(33, 203, 243, 0.4)"
    }
  };
});

const ScrollableCrateContainer = styled(Box)(({ theme }) => ({
  maxHeight: "300px", // Itt állítsd be a látható elemek számának megfelelő magasságot
  overflowY: "auto",
  scrollBehavior: "smooth",
  // Opcionális: scroll snapping, hogy az elemek szépen illeszkedjenek egymáshoz
  scrollSnapType: "y mandatory",
  "& > *": {
    scrollSnapAlign: "start"
  }
}));

// Új styled komponens a láda elemek szép megjelenítéséhez
const CrateElementCard = styled(Card)<{ rarity: string }>(({ rarity, theme }) => ({
  // Félátlátszó sötétítés, hogy a fő gradiens "átüssön" alulról
  background: 'rgba(0, 0, 0, 0.4)', 
  backdropFilter: 'blur(5px)',
  color: "#fff",
  marginBottom: theme.spacing(1),
  padding: theme.spacing(2),
  borderRadius: '12px',
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  // A rarity színt csak egy markáns bal oldali csík jelzi
  borderLeft: `6px solid ${
    rarity === 'legendary' ? '#ffaa00' : 
    rarity === 'epic' ? '#aa00ff' : 
    rarity === 'rare' ? '#0088ff' : '#999999'
  }`,
  borderBottom: '1px solid rgba(255,255,255,0.05)',
  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
  transition: "transform 0.2s ease",
  "&:hover": {
    background: 'rgba(255, 255, 255, 0.05)',
  }
}));

const Overlay = styled(Box)(({ theme }) => {
  const isDarkMode = theme.palette.mode === 'dark';
  return {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: isDarkMode
      ? 'linear-gradient(to bottom, rgba(0,0,0,0.9), rgba(40,0,0,0.8))'
      : 'linear-gradient(to bottom, rgba(10,20,60,0.8), rgba(33,203,243,0.7))',
    backdropFilter: "blur(8px)",
    zIndex: 900,
  };
});

// Új styled komponens a láda nevének megjelenítéséhez
const CrateNameLabel = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: "#fff",
  fontWeight: 700,
  fontSize: "1.2rem",
  textShadow: "1px 1px 2px rgba(0,0,0,0.8)",
  zIndex: 3,
}));

interface RewardCardProps {
  rarity?: string;
  isSpinning?: boolean;
}
const RewardCard = styled(Card)<RewardCardProps>(({ rarity, isSpinning }) => ({
  padding: "15px",
  width: "130px",
  height: "140px",
  margin: "10px",
  background: getRarityColor(rarity),
  color: "#fff",
  textAlign: "center",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  border: "1px solid rgba(255,255,255,0.2)",
  boxShadow: "0 10px 20px rgba(0,0,0,0.5)",
  transform: isSpinning
    ? "perspective(1000px) rotateY(360deg)"
    : "perspective(1000px) rotateY(0deg)",
  transition: "transform 1s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  overflow: "hidden"
}));


const SpinningContainer = styled(Box)({
  position: "fixed",
  top: "50%",
  left: 0,
  right: 0,
  transform: "translateY(-50%)",
  height: "150px",
  background: "rgba(0,0,0,0.9)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  zIndex: 1000,
});

const TopArrow = styled(Box)({
  position: 'absolute',
  top: '5%',
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '24px',
  color: 'white',
  zIndex: 1100,
});

const openRocketCrateAnimationKeyframes = keyframes({
  "0%": { transform: "rotateX(0deg)" },
  "100%": { transform: "rotateX(-90deg)" }
});

// Rocket League Nitro Case kinézetű láda konténer
const RocketCrateContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOpening' && prop !== 'caseType',
})<{ isOpening: boolean; caseType: string }>(({ isOpening, caseType, theme }) => ({
  position: "relative",
  width: "300px",
  height: "300px",
  margin: "0 auto",
  perspective: "1200px",
  transformStyle: "preserve-3d",
  "&::after": caseType !== "Elit" ? {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    //background: "linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.01), transparent)",
    pointerEvents: "none",
  } : {
    filter: "brightness(0.9)",
  }
}));


const premiumPulseAnimation = keyframes({
  "0%": { transform: "scale(1)" },
  "50%": { transform: "scale(1.05)" },
  "100%": { transform: "scale(1)" },
});

const CrateLid = styled(Box, {
  shouldForwardProp: (prop) => prop !== "caseType" && prop !== "isOpening",
})<{ caseType: string; isOpening: boolean }>(
  ({ caseType, isOpening, theme }) => {
    let gradient, borderColor;
    if (caseType === "MGP") {
      gradient = "linear-gradient(45deg, #1E90FF 30%, #00BFFF 90%)"; // kék tónusok
      borderColor = "#1E90FF";
    } else if (caseType === "Elit") {
      gradient = "linear-gradient(45deg, #C0C0C0 30%, #D3D3D3 90%)"; // ezüst
      borderColor = "#C0C0C0";
    } else if (caseType === "Premium") {
      gradient = "linear-gradient(45deg, #DAA520 30%, #FFD700 90%)"; // gazdag arany
      borderColor = "#DAA520";
    }
    
    const animationValue = (() => {
      if (isOpening) {
        if (caseType === "Premium") {
          return `${openRocketCrateAnimationKeyframes} 1s forwards, ${premiumPulseAnimation} 2s infinite`;
        }
        return `${openRocketCrateAnimationKeyframes} 1s forwards`;
      }
      if (caseType === "Premium") {
        return `${premiumPulseAnimation} 2s infinite`;
      }
      return "none";
    })();
    
    return {
      position: "relative",
      top: 0,
      left: 0,
      width: "100%",
      height: "40%",
      background: gradient,
      transformOrigin: "top",
      animation: animationValue,
      zIndex: 2,
      boxShadow: "0 4px 8px rgba(0,0,0,0.6)",
      borderTopLeftRadius: "15px",
      borderTopRightRadius: "15px",
      border: `2px solid ${borderColor}`,
    };
  }
);

const CrateBody = styled(Box, {
  shouldForwardProp: (prop) => prop !== "caseType",
})<{ caseType: string }>(
  ({ caseType, theme }) => {
    let gradient;
    if (caseType === "MGP") {
      gradient = "linear-gradient(45deg, #ADD8E6, #87CEEB)"; // világoskék árnyalatok
    } else if (caseType === "Elit") {
      gradient = "linear-gradient(45deg, #DCDCDC, #F5F5F5)"; // finom ezüst árnyalatok
    } else if (caseType === "Premium") {
      gradient = "linear-gradient(45deg, #FFF8DC, #FAFAD2)"; // krémes, aranyos tónusok
    }
    return {
      position: "absolute",
      top: "40%",
      left: 0,
      width: "100%",
      height: "60%",
      background: gradient,
      borderBottomLeftRadius: "15px",
      borderBottomRightRadius: "15px",
      boxShadow: "0 0 20px rgba(0,0,0,0.5)",
      transition: "all 0.5s ease",
      transform: "translateZ(0)",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 60%)",
        pointerEvents: "none"
      },
      animation: caseType === "Premium" ? `${premiumPulseAnimation} 2s infinite` : "none",
    };
  }
);

const ActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'darkMode',
})<{ darkMode: boolean }>(({ darkMode }) => ({
  borderRadius: '20px',
  textTransform: 'none',
  padding: '8px 20px',
  fontWeight: 'bold',
  color: darkMode ? 'white' : '#ffffff',
  backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.15)' : '#25379c',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.25)' : '#1a237e',
    transform: 'translateY(-2px)',
    boxShadow: darkMode ? '0 0 15px rgba(255, 64, 129, 0.4)' : '0 0 15px rgba(33, 203, 243, 0.4)',
  },
}));

const AnimatedDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'darkMode',
})<{ darkMode: boolean }>(({ darkMode, theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    border: darkMode ? '1px solid rgba(255, 0, 0, 0.2)' : '1px solid rgba(255, 215, 0, 0.3)',
    background: darkMode 
        ? 'linear-gradient(45deg, #000000 10%, #5e0b0b 50%, #000000 90%)' 
        : 'linear-gradient(45deg, #25379c 30%, #21cbf3 90%)',
    backgroundSize: '200% 200%',
    animation: 'backgroundMove 12s ease infinite',
    color: 'white',
    padding: theme.spacing(1),
  },
  '& .MuiDialogTitle-root': {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '1.4rem',
  },
  '& .MuiDialogContent-root': {
    color: 'rgba(255, 255, 255, 0.9)',
  }
}));


const DialogActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'darkMode',
})<{ darkMode: boolean }>(({ darkMode }) => ({
  borderRadius: '20px',
  textTransform: 'none',
  padding: '8px 20px',
  color: 'white',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    transform: 'translateY(-2px)',
    boxShadow: darkMode ? '0 0 15px rgba(255, 64, 129, 0.4)' : '0 0 15px rgba(255, 215, 0, 0.4)',
  }
}));

const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'darkMode',
})<{ darkMode: boolean }>(({ darkMode }) => ({
  color: 'white',
  background: darkMode 
    ? 'linear-gradient(135deg, rgba(94, 11, 11, 0.2) 0%, rgba(0, 0, 0, 0.4) 100%)' 
    : 'linear-gradient(135deg, rgba(37, 55, 156, 0.2) 0%, rgba(33, 203, 243, 0.2) 100%)',
  borderRadius: '12px',
  border: darkMode ? '1px solid rgba(255, 0, 0, 0.3)' : '1px solid rgba(33, 203, 243, 0.3)',
  transition: 'all 0.3s ease',
  '& .MuiSelect-select': {
    padding: '10px 15px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover': {
    background: darkMode ? 'rgba(94, 11, 11, 0.3)' : 'rgba(37, 55, 156, 0.3)',
    boxShadow: darkMode ? '0 0 10px rgba(255, 0, 0, 0.2)' : '0 0 10px rgba(33, 203, 243, 0.2)',
  },
  '& .MuiSvgIcon-root': {
    color: 'white', // A kis lefelé mutató nyíl színe
  }
}));

const selectMenuProps = (darkMode: boolean) => ({
  PaperProps: {
    sx: {
      borderRadius: '12px',
      marginTop: '8px',
      background: darkMode 
        ? 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)' 
        : 'linear-gradient(135deg, #25379c 0%, #1a237e 100%)',
      border: darkMode ? '1px solid #5e0b0b' : '1px solid #21cbf3',
      color: 'white',
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      '& .MuiMenuItem-root': {
        fontWeight: 500,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        '&.Mui-selected': {
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
          },
        },
      },
    },
  },
});

// -------------------------------------------------------------------
// 5) CaseItemsList – megjeleníti a ládában elérhető elemek típusait és esélyeit
// -------------------------------------------------------------------
const CaseItemsList = () => {
  const items = [
    { rarity: "common", label: "Common", chance: "60%" },
    { rarity: "rare", label: "Rare", chance: "25%" },
    { rarity: "epic", label: "Epic", chance: "10%" },
    { rarity: "legendary", label: "Legendary", chance: "5%" }
  ];

  return (
    <Box sx={{ 
      display: "flex", 
      justifyContent: "center", 
      flexWrap: "wrap", // Engedélyezi, hogy a kártyák új sorba ugorjanak, ha nincs hely
      my: { xs: 1, sm: 2 }, // Mobilon kisebb függőleges margó
      gap: { xs: 1, sm: 2 } // Mobilon kisebb távolság az elemek között
    }}>
      {items.map((item) => (
        <Box key={item.rarity} sx={{ textAlign: "center", m: { xs: 0.5, sm: 0 } }}>
          <RewardCard 
            rarity={item.rarity} 
            sx={{ 
              maxHeight: "25px", 
              minWidth: { xs: "70px", sm: "80px" }, // Mobilon picit keskenyebb
              p: { xs: 0.5, sm: 1 }, // Mobilon kisebb belső térköz
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Typography variant="caption" sx={{ fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
              {item.label}
            </Typography>
          </RewardCard>
          <Typography variant="caption" sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' }, display: 'block', mt: 0.5 }}>
            {item.chance}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

// -------------------------------------------------------------------
// 6) CaseOpening komponens
// -------------------------------------------------------------------
const CaseOpening: React.FC = () => {
  interface Reward {
    id: string;
    name: string;
    rarity: string;
    price: number;
    image: string;
  }

  const isAuthenticated = !!Cookies.get('token');

  // Állapotok
  const [selectedCase, setSelectedCase] = useState<string>("");
  const [isMuted, setIsMuted] = useState(false);
  const [isOpening, setIsOpening] = useState(false);
  const [stats, setStats] = useState({ opened: 0, legendary: 0 });
  const [showReward, setShowReward] = useState(false);
  const [currentReward, setCurrentReward] = useState<Reward | null>(null);
  const [showSpinning, setShowSpinning] = useState(false);
  const [spinningItems, setSpinningItems] = useState<Reward[]>([]);
  const [userToken, setUserToken] = useState<string | number>(0);
  const animationRef = useRef<number | null>(null);
  const translatedItemsRef = useRef<HTMLDivElement>(null);
  const [cratePrice, setCratePrice] = useState(0);
  const [crateProductName, setCrateProductName] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [crateElements, setCrateElements] = useState<Reward[]>([]);
  const [caseActiveStatus, setCaseActiveStatus] = useState<{ [key: string]: boolean }>({
    MGP: false,
    Elit: false,
    Premium: false,
  });
  const { hasPermission } = useUserPermissions();
  const isPremiumCase = selectedCase === "Premium";
  const canBuyCrate = !isPremiumCase || hasPermission("OnyxOverlord");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const [loginPromptOpen, setLoginPromptOpen] = useState(false);
  const audioRef = useRef(new Audio(OpeningSound));

  useEffect(() => {
    audioRef.current.muted = isMuted;
    audioRef.current.loop = true; 
  }, [isMuted]);

  const startOpeningAudio = () => {
    if (!isMuted) {
      audioRef.current.currentTime = 0; // Újraindítás az elejéről
      audioRef.current.play().catch(err => console.log("Audio play failed:", err));
    }
  };

  // Case definíciók
  const cases = [
      { id: "MGP", name: "MGP Case" },
      { id: "Elit", name: "Elit Case" },
      { id: "Premium", name: "Premium Case" } 
    ];
    
    

  // API hívásokhoz segédfüggvények

const getCrateData = async (): Promise<Reward[]> => {
  let url = "";
  if (selectedCase === "MGP") {
    url = `${process.env.REACT_APP_API_URL}/v1/user/caseopening/getmgpcrate`;
  } else if (selectedCase === "Elit") {
    url = `${process.env.REACT_APP_API_URL}/v1/user/caseopening/getelitcrate`;
  } else if (selectedCase === "Premium") {
    url = `${process.env.REACT_APP_API_URL}/v1/user/caseopening/getpremiumcrate`
  }
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${Cookies.get('token')}` }
  });
  const data = await response.json();

  if (data && data.length > 0) {
    // Frissítjük a selectedCase active státuszát
    setCaseActiveStatus(prev => ({ ...prev, [selectedCase]: data[0].active }));
  } else {
    setCaseActiveStatus(prev => ({ ...prev, [selectedCase]: false }));
  }

  const rewards: Reward[] = data
    .filter((item: any) => {
      // Csak azokat az elemeket fogadjuk el, ahol productType és typeName létezik és active true
      if (!item.productType || !item.productType.typeName) {
        return false;
      }
      if (item.active === false) return false;
      return true;
    })
    .map((item: any) => {
      let rarity = "";
      const type = item.productType.typeName.toLowerCase();
      if (type.includes("common")) {
        rarity = "common";
      } else if (type.includes("rare")) {
        rarity = "rare";
      } else if (type.includes("epic")) {
        rarity = "epic";
      } else if (type.includes("legendary")) {
        rarity = "legendary";
      }
      // Ha a productnak nincs rarity (azaz rarity === ""), akkor ez egy láda (case)
      return {
        id: item.id.toString(),
        name: item.productName,
        rarity: rarity, 
        price: item.price,
        image: item.image || "", 
        productType: item.productType
      };
    });
  return rewards;
};

  
  useEffect(() => {
    const fetchCratePriceAndElements = async () => {
      try {
        const crateData = await getCrateData();
        // Beállítjuk a láda elemeit
        setCrateElements(crateData);
        
        const targetType = `${selectedCase.toLowerCase()}_crate`;
        const crateObj = crateData.find((item) =>
          item.productType!.typeName.toLowerCase() === targetType
        );
        if (crateObj) {
          setCratePrice(crateObj.price);
          setCrateProductName(crateObj.productType!.typeName);
        } else {
          setAlertMessage("Crate not found for selected case.");
          setAlertOpen(true);
        }
      } catch (error) {
        console.error("Error fetching crate data:", error);
        setAlertMessage("Error fetching crate data.");
        setAlertOpen(true);
      }
    };
      if (selectedCase) {
          fetchCratePriceAndElements();
        }
  }, [selectedCase]);
  
  useEffect(() => {
    const fetchCratePrice = async () => {
      try {
        const crateData = await getCrateData();
        // A targetType itt "mgp_crate" (kisbetűs) várható, ezért
        // a productType.typeName-t kisbetűssé tesszük az összehasonlításhoz.
        const targetType = `${selectedCase.toLowerCase()}_crate`; // pl.: "mgp_crate" vagy "elit_crate"
        const crateObj = crateData.find((item) =>
          item.productType!.typeName.toLowerCase() === targetType
        );
        if (crateObj) {
          // Fontos: crateProductName-t a productType.typeName értékére állítjuk,
          // mert az API a "MGP_crate" formátumban várja.
          setCratePrice(crateObj.price);
          setCrateProductName(crateObj.productType!.typeName);
        } else {
          setAlertMessage("Crate not found for selected case.");
          setAlertOpen(true);
        }
      } catch (error) {
        console.error("Error fetching crate data:", error);
        setAlertMessage("Error fetching crate data.");
        setAlertOpen(true);
      }
    };
      if (selectedCase) {
          fetchCratePrice();
        }
  }, [selectedCase]);
  
  // useEffect, ami oldal betöltésekor lekéri az API-ból a ládák active értékét
  useEffect(() => {
    const fetchAllCrateActiveStatuses = async () => {
      const statuses: { [key: string]: boolean } = {};
      for (const crate of cases) {
        let url = "";
        if (crate.id === "MGP") {
          url = `${process.env.REACT_APP_API_URL}/v1/user/caseopening/getmgpcrate`;
        } else if (crate.id === "Elit") {
          url = `${process.env.REACT_APP_API_URL}/v1/user/caseopening/getelitcrate`
        } else if (crate.id === "Premium") {
          url = `${process.env.REACT_APP_API_URL}/v1/user/caseopening/getpremiumcrate`;
        }
        try {
          const response = await fetch(url, {
            headers: { Authorization: `Bearer ${Cookies.get('token')}` }
          });
          const data = await response.json();
          statuses[crate.id] = data && data.length > 0 ? data[0].active : false;
        } catch (error) {
          console.error(`Error fetching ${crate.id} active status:`, error);
          statuses[crate.id] = false;
        }
      }
      setCaseActiveStatus(statuses);
    };
    fetchAllCrateActiveStatuses();
  }, []);


  useEffect(() => {
    const availableCases = cases.filter(c => caseActiveStatus[c.id]);
    if (availableCases.length > 0) {
      // Ha a jelenlegi selectedCase nincs az aktívak között, akkor állítsuk át az első elérhetőre
      if (!availableCases.some(c => c.id === selectedCase)) {
        setSelectedCase(availableCases[0].id);
      }
    } else {
      // Ha nincs aktív láda, állítsuk üresre
      setSelectedCase("");
    }
  }, [caseActiveStatus, selectedCase, cases]);

  const startTestSpin = async () => {
    if (showSpinning) return;
  
    const spinArray = await createSpinArray();
    setSpinningItems(spinArray);
  
    const initialIndex = 6;
    const initialOffset = computeOffset(initialIndex, itemWidthValue, containerWidthValue);
    const finalIndex = 96;
    const computedFinalOffset = computeOffset(finalIndex, itemWidthValue, containerWidthValue);
    const targetOffset = computedFinalOffset;
    const distance = targetOffset - initialOffset;
    const speed = 1;
    const duration = distance / speed;
    const startTime = Date.now();
    setShowSpinning(true);
  
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentOffset = initialOffset + (targetOffset - initialOffset) * easeOut(progress);
      if (translatedItemsRef.current) {
        translatedItemsRef.current.style.transform = `translateX(-${currentOffset}px)`;
      }
      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        if (translatedItemsRef.current) {
          translatedItemsRef.current.style.transform = `translateX(-${targetOffset}px)`;
        }
        setTimeout(() => {
          setShowSpinning(false);
          setStats((prev) => ({
            opened: prev.opened + 1,
            legendary: prev.legendary + (spinArray[96].rarity === "legendary" ? 1 : 0),
          }));
          setCurrentReward(spinArray[96]);
          setShowReward(true);
        }, 3000);
      }
    };
    animationRef.current = requestAnimationFrame(animate);
  };

// Új függvény: crate vásárlás
const buyCrate = async () => {
  if (!isAuthenticated) {
    setLoginPromptOpen(true);
    return;
  }

  try {
    if (Number(userToken) < cratePrice) {
      setAlertMessage("Not enough tokens to buy this crate.");
      setAlertOpen(true);
      return;
    }

    const res = await fetch(`${process.env.REACT_APP_API_URL}/v1/user/buycrate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get('token')}`
      },
      body: JSON.stringify({ 
        price: cratePrice.toString(), 
        product_name: crateProductName 
      })
    });

    if (!res.ok) {
      setAlertMessage("Error buying crate.");
      setAlertOpen(true);
      return;
    }

    // Ha a vásárlás sikeres, indítjuk a hangot és a nyitást
    startOpeningAudioWithDelay(); 
    openCase();

  } catch (error) {
    console.error("Error buying crate:", error);
    setAlertMessage("Error buying crate.");
    setAlertOpen(true);
  }
};


const fetchUserToken = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/v1/user/getusertoken`, {
      headers: { Authorization: `Bearer ${Cookies.get('token')}` }
    });
    if (res.ok) {
      const data = await res.json();
      setUserToken(data.token);
    } else {
      console.error('Failed to fetch tokens');
    }
  } catch (error) {
    console.error("Error fetching user token:", error);
  }
};

// Súlyozott véletlenszerű választó függvény
const weightedRandomReward = (rewards: Reward[]): Reward => {
  // Súlyok a raritásokhoz:
  // common: 60, rare: 25, epic: 10, legendary: 5
  const weightMap: Record<string, number> = {
    common: 60,
    rare: 25,
    epic: 10,
    legendary: 5,
  };

  let totalWeight = 0;
  const weights = rewards.map(r => {
    const w = weightMap[r.rarity] || 0;
    totalWeight += w;
    return w;
  });
  const random = Math.random() * totalWeight;
  let sum = 0;
  for (let i = 0; i < rewards.length; i++) {
    sum += weights[i];
    if (random < sum) {
      return rewards[i];
    }
  }
  return rewards[rewards.length - 1];
};

// Csak akkor hívjuk meg az API-t, ha a felhasználó be van jelentkezve
useEffect(() => {
  if (isAuthenticated) {
    fetchUserToken();
  }
}, [isAuthenticated]);

  // Segédfüggvény az offset számításához:
  const computeOffset = (index: number, itemWidth: number, containerWidth: number) =>
    index * itemWidth + itemWidth / 2 - containerWidth / 2;

  // Scroll tiltása pörgetés alatt
  useEffect(() => {
    document.body.style.overflow = showSpinning ? "hidden" : "auto";
  }, [showSpinning]);

  // Létrehozza a 97 elemből álló spinning array-t,
  // ahol a finalReward fixen a 97. elem (index 96) lesz.
  const createSpinArray = async (): Promise<Reward[]> => {
    const crateData = await getCrateData();
    const spinArray: Reward[] = [];
    // Súlyozottan választjuk ki a final rewardot
    const finalReward = weightedRandomReward(crateData);
    for (let i = 0; i < 97; i++) {
      if (i === 96) {
        spinArray.push(finalReward);
      } else {
        // Egyenlő eséllyel választunk a többi elem közül
        spinArray.push(crateData[Math.floor(Math.random() * crateData.length)]);
      }
    }
    return spinArray;
  };

  // A pörgetés animációját indító függvény
  const startSpin = async () => {
    if (showSpinning) return;
  
    const spinArray = await createSpinArray();
    setSpinningItems(spinArray);
  
    const initialIndex = 6;
    const initialOffset = computeOffset(initialIndex, itemWidthValue, containerWidthValue);
    const finalIndex = 96;
    const computedFinalOffset = computeOffset(finalIndex, itemWidthValue, containerWidthValue);
    const targetOffset = computedFinalOffset;
    const distance = targetOffset - initialOffset;
    const speed = 1;
    const duration = distance / speed;
    const startTime = Date.now();
    setShowSpinning(true);
  
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentOffset = initialOffset + (targetOffset - initialOffset) * easeOut(progress);
      if (translatedItemsRef.current) {
        translatedItemsRef.current.style.transform = `translateX(-${currentOffset}px)`;
      }

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        if (translatedItemsRef.current) {
          translatedItemsRef.current.style.transform = `translateX(-${targetOffset}px)`;
        }
        setTimeout(async () => {
          setShowSpinning(false);
          setStats((prev) => ({
            opened: prev.opened + 1,
            legendary: prev.legendary + (spinArray[96].rarity === "legendary" ? 1 : 0),
          }));
          setCurrentReward(spinArray[96]);
          // Token frissítése: először meghívjuk az updatetoken API-t...
          try {
            await fetch(`${process.env.REACT_APP_API_URL}/v1/user/updatetoken`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get('token')}`
              },
              body: JSON.stringify({ price: spinArray[96].price.toString() })
            });
            // ...majd újra lekérjük a felhasználó aktuális tokenjét.
            await fetchUserToken();
          } catch (error) {
            console.error("Error updating token:", error);
          }
          
          setShowReward(true);
        }, 3000);
      }
    };

    animationRef.current = requestAnimationFrame(animate);
  };

  // Az openCase függvény elindítja a pörgetést
  const openCase = () => {
    startOpeningAudio();
    setIsOpening(true);
    setTimeout(() => {
      startSpin();
    }, 500);
  };

  const testOpenCase = () => {
    // A teszt nyitáshoz nem kell isAuthenticated ellenőrzés
    startOpeningAudioWithDelay(); // Hang indítása 1 mp késleltetéssel
    setIsOpening(true);
    
    setTimeout(() => {
      startTestSpin();
    }, 500);
  };

  const stopOpeningAudio = () => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  };

  useEffect(() => {
    if (showReward) {
      stopOpeningAudio();
    }
  }, [showReward]);

  // Némítás kezelése menet közben
  useEffect(() => {
    audioRef.current.muted = isMuted;
  }, [isMuted]);

  const startOpeningAudioWithDelay = () => {
    if (!isMuted) {
      // Először megállítjuk, ha esetleg már futna (pl. gyors egymásutáni gombnyomás)
      stopOpeningAudio(); 
      
      setTimeout(() => {
        // Csak akkor indul el, ha a felhasználó nem némította el közben
        if (!isMuted) {
          audioRef.current.play().catch(err => console.log("Audio play failed:", err));
        }
      }, 1000); // Pontosan 1 másodperces késleltetés
    }
  };

  // Ha bezáródik a gratulációs dialógus, reseteljük a láda állapotát
  const handleRewardClose = () => {
    setShowReward(false);
    setCurrentReward(null);
    stopOpeningAudio();
    setIsOpening(false);
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh', overflowX: 'hidden' }}>
      {/* Háttér Particles */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
        <Particles />
      </div>

      {/* Navigáció */}
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      {/* Mobilon kisebb padding top */}
      <Container maxWidth="lg" sx={{ pt: { xs: 2, md: 4 }, mt: '64px' }}>
        <Typography variant="h3" gutterBottom align="center" sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
          Case Opener
        </Typography>

        {/* A felhasználó aktuális tokenje */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
            {isAuthenticated ? (
              <Typography variant="h6" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
                Your Token: {userToken}
              </Typography>
            ) : (
              <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.25rem' } }}>
                Sign in/Sign up to get tokens!
              </Typography>
            )}
          </Box>

        {/* Lista az esetben található elemekről és esélyekről */}
        <CaseItemsList />

        <Grid container spacing={3}>
          {/* Bal oldal: Láda és pörgetés */}
          <Grid item xs={12} md={8}>
            <StyledCase>
              
              {/* Fejléc: Láda választó és némító gomb (Mobilon egymás alá kerülnek) */}
              <Box sx={{ 
                mb: 2, 
                display: "flex", 
                flexDirection: { xs: 'column', sm: 'row' }, 
                justifyContent: "space-between", 
                alignItems: "center",
                gap: { xs: 2, sm: 0 }
              }}>
                <StyledSelect
                  value={selectedCase}
                  onChange={(e) => setSelectedCase(e.target.value)}
                  darkMode={isDarkMode}
                  MenuProps={selectMenuProps(isDarkMode)}
                  sx={{ minWidth: { xs: '100%', sm: 220 } }}
                >
                  {cases.filter(c => caseActiveStatus[c.id]).map(c => (
                    <MenuItem key={c.id} value={c.id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        {c.name}
                        {c.name === "Premium Case" && (
                          <FaCrown style={{ 
                            color: "blue", 
                            marginLeft: 8,
                            filter: 'drop-shadow(0 0 2px rgba(255,215,0,0.5))' 
                          }} />
                        )}
                      </Box>
                    </MenuItem>
                  ))}
                </StyledSelect>

                <IconButton 
                  onClick={() => setIsMuted(!isMuted)}
                  sx={{ 
                    color: isMuted ? 'error.main' : (isDarkMode ? '#fff' : '#25379c'),
                    transition: 'all 0.3s ease',
                    alignSelf: { xs: 'flex-end', sm: 'auto' }
                  }}
                >
                  {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                </IconButton>
              </Box>

              {/* Láda */}
              <Box sx={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
                <RocketCrateContainer isOpening={isOpening} caseType={selectedCase}>
                  <CrateLid caseType={selectedCase} isOpening={isOpening}>
                    <CrateNameLabel>
                      {cases.find(c => c.id === selectedCase)?.name}
                    </CrateNameLabel>
                  </CrateLid>
                  <CrateBody caseType={selectedCase} />
                </RocketCrateContainer>
              </Box>

              {/* Gombok a láda kinyitásához - Pontosan a láda közepe alatt */}
              <Box sx={{ 
                textAlign: "center", 
                mt: 4,
                display: 'flex',
                flexDirection: 'column', // Ezzel kerülnek pontosan egymás és a láda alá
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2 // Távolság a két gomb között
              }}>
                
                {/* 1. BUY GOMB (Fő akció, felül) */}
                <Tooltip
                  title={isPremiumCase && !canBuyCrate ? "Requires at least OnyxOverlord rank to purchase Premium Case" : ""}
                  arrow
                >
                  <span style={{ display: 'block', width: 'auto' }}> 
                    <ActionButton
                      darkMode={isDarkMode}
                      onClick={buyCrate}
                      disabled={isOpening || (isPremiumCase && !canBuyCrate)}
                      sx={{
                        width: { xs: '100%', sm: '280px' }, // Kicsit szélesebb, dominánsabb
                        py: 1.5, // Kicsit magasabb
                        fontSize: '1.1rem',
                        boxShadow: (!isOpening && canBuyCrate) ? '0 0 15px rgba(255, 215, 0, 0.5)' : 'none',
                        animation: isOpening ? "pulse 1s infinite" : "none",
                        "@keyframes pulse": {
                          "0%": { transform: "scale(1)" },
                          "50%": { transform: "scale(1.05)" },
                          "100%": { transform: "scale(1)" }
                        }
                      }}
                    >
                      {isOpening ? "Opening..." : `Buy crate for ${cratePrice} token`}
                    </ActionButton>
                  </span>
                </Tooltip>

                {/* 2. TEST OPEN GOMB (Másodlagos akció, alul) */}
                {isAuthenticated ? (
                  <ActionButton
                    darkMode={isDarkMode}
                    onClick={testOpenCase}
                    disabled={isOpening}
                    sx={{
                      width: { xs: '100%', sm: '200px' },
                      opacity: 0.8, // Picit halványabb, hogy ne vonja el a figyelmet a vásárlásról
                      animation: isOpening ? "pulse 1s infinite" : "none",
                    }}
                  >
                    {isOpening ? "Opening..." : "Test Open"}
                  </ActionButton>
                ) : (
                  <ActionButton
                    darkMode={isDarkMode}
                    onClick={testOpenCase}
                    disabled={isOpening}
                    sx={{
                      width: { xs: '100%', sm: '200px' },
                      opacity: 0.8,
                      animation: isOpening ? "pulse 1s infinite" : "none",
                    }}
                  >
                    {isOpening ? "Opening..." : "Test Open"}
                  </ActionButton>
                )}

              </Box>
            </StyledCase>

           {/* Pörgetés overlay és animáció */}
           {showSpinning && <Overlay />}
            {showSpinning && (
              // A SpinningContainer-nek 100% szélesnek kell lennie mobilon, ezt CSS-ből vagy sx-ből kell megadni
              <SpinningContainer style={{ width: '100%', maxWidth: '100vw', overflow: 'hidden' }}>
                <TranslatedItems ref={translatedItemsRef} offset={0}>
                  
                  {/* Először a spinningItems elemek */}
                  {spinningItems.map((item, index) => (
                    <RewardCard
                      key={`original-${item.id}-${index}`}
                      rarity={item.rarity}
                      sx={{ 
                        // Mobilon picit kisebb kártyák
                        minWidth: { xs: "100px", sm: "130px" }, 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        gap: 1
                      }}
                    >
                      {/* --- Név helyett Kép --- */}
                      {item.image ? (
                        <Box 
                          component="img" 
                          src={item.image} 
                          alt={item.name} 
                          sx={{ width: { xs: 60, sm: 80 }, height: { xs: 60, sm: 80 }, objectFit: 'contain' }} 
                        />
                      ) : (
                        <Typography variant="body2" sx={{ opacity: 0.5, fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>{item.name}</Typography>
                      )}
                      <Typography sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>{item.price} token</Typography>
                    </RewardCard>
                  ))}

                  {/* Extra 50 elem */}
                  {spinningItems.length > 0 &&
                  Array.from({ length: 50 }, (_, i) => {
                    const finalReward = spinningItems[spinningItems.length - 1];
                    const randomItem = spinningItems[Math.floor(Math.random() * spinningItems.length)];
                    const extraItem = i === 24 ? finalReward : randomItem;
                    return (
                      <RewardCard
                        key={`extra-${i}`}
                        rarity={extraItem.rarity}
                        sx={{ 
                          minWidth: { xs: "100px", sm: "130px" },
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: 1
                        }}
                      >
                        {/* --- Név helyett Kép (Extra elemeknél is) --- */}
                        {extraItem.image ? (
                          <Box 
                            component="img" 
                            src={extraItem.image} 
                            alt={extraItem.name} 
                            sx={{ width: { xs: 60, sm: 80 }, height: { xs: 60, sm: 80 }, objectFit: 'contain' }} 
                          />
                        ) : (
                          <Typography variant="body2" sx={{ opacity: 0.5, fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>{extraItem.name}</Typography>
                        )}
                        <Typography sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>{extraItem.price} token</Typography>
                      </RewardCard>
                    );
                  })
                }
                </TranslatedItems>
                <TopArrow>
                  <FaArrowDown />
                </TopArrow>
              </SpinningContainer>
            )}

            {/* Gratulációs dialógus */}
            <AnimatedDialog 
              open={showReward} 
              onClose={handleRewardClose} 
              darkMode={isDarkMode}
              maxWidth="xs"
              fullWidth
              TransitionComponent={Transition}
            >
              <Box sx={{ p: { xs: 2, sm: 4 }, textAlign: "center" }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, fontSize: { xs: '1.8rem', sm: '2.125rem' } }}>
                  Congratulations!
                </Typography>

                <RewardCard 
                  rarity={currentReward?.rarity || 'common'} 
                  sx={{ 
                    mx: "auto", 
                    width: { xs: '150px', sm: '200px' }, 
                    height: { xs: '150px', sm: '200px' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255,255,255,0.05)',
                    perspective: '1000px' 
                  }}
                >
                  {currentReward && (
                    <Box
                      sx={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: `float 3s ease-in-out infinite`,
                        '@keyframes float': {
                          '0%, 100%': { transform: 'translateY(0)' },
                          '50%': { transform: 'translateY(-10px)' },
                        }
                      }}
                    >
                      {/* --- DINAMIKUS KÉP MEGJELENÍTÉSE --- */}
                      {currentReward.image ? (
                        <Box
                          component="img"
                          src={currentReward.image}
                          alt={currentReward.name}
                          sx={{ 
                            maxWidth: { xs: "90px", sm: "130px" }, 
                            maxHeight: { xs: "90px", sm: "130px" },
                            objectFit: "contain",
                            filter: 'drop-shadow(0 0 20px rgba(255, 215, 0, 0.7))',
                          }}
                        />
                      ) : (
                        <Typography variant="h6" sx={{ color: 'white', textShadow: '0 0 10px gold', fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                          {currentReward.name}
                        </Typography>
                      )}
                    </Box>
                  )}
                </RewardCard>

                <Typography variant="h5" sx={{ mt: 4, fontWeight: 600, fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
                  You won {currentReward?.price || 0} token!
                </Typography>
                
                <Typography variant="subtitle1" sx={{ mt: 1, opacity: 0.8, fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                  Item: {currentReward?.name}
                </Typography>

                <DialogActionButton 
                  darkMode={isDarkMode} 
                  onClick={handleRewardClose}
                  sx={{ mt: 3, width: { xs: '100%', sm: 'auto' }, minWidth: '150px' }}
                >
                  Awesome!
                </DialogActionButton>
              </Box>
            </AnimatedDialog>
          </Grid>

          {/* Jobb oldal: Statisztikák és Crate elements */}
          <Grid item xs={12} md={4}>
            <StyledCase>
              <Typography variant="h6" gutterBottom>
                Statistics
              </Typography>
              <Typography variant="body2">Cases Opened: {stats.opened}</Typography>
              <Typography variant="body2">Legendary Items: {stats.legendary}</Typography>
              <Typography variant="body2">
                {isAuthenticated ? `Your Token: ${userToken}` : "Sign in/Sign up to get tokens!"}
              </Typography>
            </StyledCase>

            {/* Crate elements szép megjelenítéssel és görgetéssel */}
            <StyledCase sx={{ mt: 2, maxWidth: '100%', mx: 'auto' }}>
              <Typography variant="h6" gutterBottom>
                Crate elements:
              </Typography>
              {crateElements.length > 0 ? (
                <ScrollableCrateContainer>
                  {crateElements.map((element) => (
                    <CrateElementCard key={element.id} rarity={element.rarity} sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                      
                      {/* --- Kép és Név egymás mellett --- */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                        
                        {/* Termék képe */}
                        {element.image ? (
                          <Box 
                            component="img" 
                            src={element.image} 
                            alt={element.name} 
                            sx={{ width: { xs: 40, sm: 50 }, height: { xs: 40, sm: 50 }, objectFit: 'contain', borderRadius: 1 }} 
                          />
                        ) : (
                          <Box sx={{ 
                            width: { xs: 40, sm: 50 }, height: { xs: 40, sm: 50 }, 
                            display: 'flex', alignItems: 'center', justifyContent: 'center', 
                            bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 1 
                          }}>
                            <Typography variant="caption" sx={{ opacity: 0.5, fontSize: { xs: '0.6rem', sm: '0.75rem' } }}>No img</Typography>
                          </Box>
                        )}

                        {/* Termék neve és ritkasága */}
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2, fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                            {element.name}
                          </Typography>
                          <Typography variant="caption" sx={{ opacity: 0.8 }}>
                            Rarity: {element.rarity}
                          </Typography>
                        </Box>

                        <Typography variant="subtitle2" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                          {element.price} token
                        </Typography>
                      </Box>
                    </CrateElementCard>
                  ))}
                </ScrollableCrateContainer>
              ) : (
                <Typography variant="body2">No elements found.</Typography>
              )}
            </StyledCase>
          </Grid>
        </Grid>
        
        {/* Hiba / Figyelmeztető Dialógus (pl. Nincs elég token) */}
        <AnimatedDialog 
          open={alertOpen} 
          onClose={() => setAlertOpen(false)} 
          darkMode={isDarkMode}
          TransitionComponent={Zoom}
          transitionDuration={400}
          maxWidth="xs"
          fullWidth
          disableScrollLock
        >
          <DialogTitle sx={{ color: isDarkMode ? '#ff5252' : '#d32f2f' }}>
            ⚠️ Notice
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center", mt: 2 }}>
            <Typography 
              variant="h6" 
              sx={{ 
                color: isDarkMode ? 'rgba(255,255,255,0.9)' : '#1a237e',
                lineHeight: 1.5 
              }}
            >
              {alertMessage}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
            <ActionButton 
              darkMode={isDarkMode} 
              onClick={() => setAlertOpen(false)} 
              sx={{ minWidth: '120px', mt: 1 }}
            >
              Got it
            </ActionButton>
          </DialogActions>
        </AnimatedDialog>

        {/* Login Prompt Dialógus */}
        <AnimatedDialog open={loginPromptOpen} onClose={() => setLoginPromptOpen(false)} disableScrollLock darkMode={isDarkMode}>
          <DialogTitle sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>Authentication Required</DialogTitle>
          <DialogContent>
            <Alert severity="warning" sx={{ mb: 2, borderRadius: '12px' }}>You need to be logged in to buy a crate!</Alert>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" sx={{ mt: 2 }}>
              <DialogActionButton darkMode={isDarkMode} onClick={() => navigate('/login')} sx={{ width: { xs: '100%', sm: 'auto' } }}>Sign In</DialogActionButton>
              <DialogActionButton darkMode={isDarkMode} onClick={() => navigate('/register')} sx={{ width: { xs: '100%', sm: 'auto' } }}>Sign Up</DialogActionButton>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
            <Button onClick={() => setLoginPromptOpen(false)} sx={{ color: 'white' }}>Maybe later</Button>
          </DialogActions>
        </AnimatedDialog>

      </Container>
    </div>
  );
};


export default CaseOpening;
